import React, { useState } from 'react';
import { View, Text, Image, TextInput, TouchableOpacity, StyleSheet, Animated, Easing } from 'react-native';
import LogoImage from './assets/images/logo.png';
import MenuPanel from './menuPanel';
import MenuIcon from './assets/icons/menu.png'; // o qualsiasi libreria di icone
//import { useNavigation } from '@react-navigation/native';
import { useNavigate } from 'react-router-dom';

import Cart from './assets/icons/bag.png';

const NavBar = ({ toggleMenu }) => {

  //const navigation = useNavigation();
const navigate = useNavigate();
  const handleCartPage = () => {
    const direction="cart";
    navigate(`/${direction.toLowerCase()}`);
  };
  return (
    <View style={styles.navBar}>
            <View style={styles.logoContainer}>
     <TouchableOpacity onPress={toggleMenu} style={styles.menuButton}>
      <Image source={MenuIcon} style={styles.menuIcon} />
    </TouchableOpacity>
</View>
      <View style={styles.logoContainer}>
        <Image source={LogoImage} style={styles.logo} />
      </View>

      <View style={styles.logoContainer}>
      {/* <TextInput style={styles.searchInput} placeholder="edizioni Limitate..." /> */}
      <TouchableOpacity  onPress={handleCartPage} style={styles.menuButton}>
      <Image source={Cart} style={styles.menuIcon} />
    </TouchableOpacity>
      </View>
    </View>
  );
};


const styles = StyleSheet.create({
  navBar: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height:60,
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 5,
    backgroundColor: '#ffffff',
    borderBottomWidth: 1, // Aggiunge una linea al fondo
    borderBottomColor: '#F0F0F0', // Colore chiarissimo della linea

  },
  menuPanel:{
zIndex:2,
  },
  menuButton: {
    width:50,
    alignItems: 'center', // Centra l'icona orizzontalmente
  },
  menuIcon: {
    width: 25,  // Imposta la larghezza dell'icona
    height: 25, // Imposta l'altezza dell'icona
    resizeMode: 'contain', // Mantieni le proporzioni dell'icona
    alignItems: 'center', // Centra l'icona orizzontalmente
    Color:'#000'
  },
  menuText: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  logoContainer: {
    height: 50,
    width:30,
    flexDirection: 'column', // Assicurati che gli elementi siano disposti verticalmente
    justifyContent: 'center', // Centra l'icona verticalmente
    alignItems: 'center', // Centra l'icona orizzontalmente
  },
  logo: {
    width:100,
    height: 50,
  },
  searchInput: {
    height: 40,
    flexDirection: 'column', // Assicurati che gli elementi siano disposti verticalmente
    justifyContent: 'center', // Centra l'icona verticalmente
    alignItems: 'center', // Centra l'icona orizzontalmente
    borderColor: '#ccc',
    borderWidth: 1,
    borderRadius: 5,
    paddingHorizontal: 10,
    width: 100,
  },
});

export default NavBar;
